import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './WebDevHero.css';

const WebDevHero = () => {
  return (
    <Box className="web-dev-hero">
      <div className="web-dev-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="web-dev-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="web-dev-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h1"
            className="web-dev-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            WEB DEVELOPMENT
          </Typography>
          <Typography
            className="web-dev-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Create powerful, responsive, and engaging web experiences with our expert web development services. 
            From dynamic web applications to e-commerce platforms, we deliver modern solutions that drive 
            digital success and user engagement. Our team combines cutting-edge technologies with best practices 
            to build scalable and secure web solutions.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default WebDevHero; 